import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { z } from "zod";
import { api } from "@/convex/_generated/api";
import type { Id } from "@/convex/_generated/dataModel";

// Conserva lo que traiga la URL (busqueda, filtros, `action=create`).
const indexSearchSchema = z.object({}).passthrough();

export const Route = createFileRoute("/_authenticated/collections/$collectionId/")({
  validateSearch: indexSearchSchema,
  component: CollectionDefaultView,
});

/**
 * `/collections/$id` abre la vista predeterminada: la que eligió el usuario
 * o, si no eligió, la primera del orden de la colección (Configuración →
 * Colecciones → Vistas).
 */
function CollectionDefaultView() {
  const { collectionId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();
  const views = useQuery(api.companies.collections.kanban.getCollectionViews, {
    collectionId: collectionId as Id<"collections">,
  });

  useEffect(() => {
    if (views === undefined) return;
    const first = views?.views[0] ?? "table";
    void navigate({
      to: `/collections/$collectionId/${first}` as const,
      params: { collectionId },
      search: search as never,
      replace: true,
    });
  }, [views, collectionId, navigate, search]);

  return null;
}
